import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';

const API_URL = process.env.API_URL;

export async function getList() {
  const url = `${API_URL}/admin/app-setting/home-section`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetail(id) {
  const url = `${API_URL}/admin/app-setting/home-section/detail/${id}`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function create(data) {
  const url = `${API_URL}/admin/app-setting/home-section`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function update(id, data) {
  const url = `${API_URL}/admin/app-setting/home-section/${id}`;
  return axios({ url,
    method: 'put',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteSection(id) {
  const url = `${API_URL}/admin/app-setting/home-section/${id}`;
  return axios({ url,
    method: 'delete',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function reorderSection(data) {
  const url = `${API_URL}/admin/app-setting/home-section/re-order`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function publishSection(data) {
  const url = `${API_URL}/admin/app-setting/home-section/update-publish`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addContent(sectionId, data) {
  const url = `${API_URL}/admin/app-setting/home-section/${sectionId}/content`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteContent(id) {
  const url = `${API_URL}/admin/app-setting/home-section/content/${id}`;
  return axios({ url,
    method: 'delete',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function reorderContent(sectionId, data) {
  const url = `${API_URL}/admin/app-setting/home-section/${sectionId}/content/re-order`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/homesection.js